import axios from 'axios';
import { APP_URI } from './config/env';

export const axiosInstance = axios.create({
    baseURL: APP_URI
  })

  axiosInstance.interceptors.request.use(function (config) {
    // console.log('------------------------', config);
    if(config.url.indexOf('register') > -1 || config.url.indexOf('login') > -1) {
      return config;
    }
    const token = sessionStorage.getItem('x-auth-token');
       if (token) {
           config.headers['Authorization'] = 'Bearer ' + token;
       }

       if(config.url.indexOf('export') > -1) {
         config.responseType = 'blob';
       }
       // config.headers['Content-Type'] = 'application/json';
    return config;
  }, function (error) {
    // Do something with request error
    return Promise.reject(error);
  });

  // response parse
  axiosInstance.interceptors.response.use((response) => {
  return response.data;
}, error => {
  console.warn('Error status', error);
  // return Promise.reject(error)
  if (error.response) {
    if(error.response?.status === 401 && window.location.pathname != '/login') {
      sessionStorage.clear();
      window.location = '/login';
    }
    console.warn('Error status', error.response);
    return Promise.reject(error.response);
  } else {
    return Promise.reject(error);
  }
})
